type Colors = {
  [key: string]: string;
};

export const colors: Colors = {
  black: '#fff',
  gold: '#d4af37',
  yellow: '#FFFF00',
  green: '#008000',
  midnightgreen: '#004953',
  silver: '#c0c0c0',
  spacegray: '#343d46',
  red: '#FF0000',
  white: '#fff',
  purple: '#800080',
  coral: '#FF7F50',
  rosegold: '#B76E79',
  midnight: '#000e34',
  spaceblack: '#505150',
  blue: '#0000ff',
  pink: '#FFC0CB',
  sierrablue: '#BFDAF7',
  graphite: '#251607',
  'space gray': '#343d46',
  'space-gray': '#343d46',
  'rose gold': '#B76E79',
  'sky-blue': '#87CEEB',
  starlight: '#F8F9EC',
};
